
<template>
  <div class="row">



    <div>
      <p>Czy na pewno chcesz potwierdzić płatność?</p>
      <p>(<b>{{paymentLocal.documentIds.length}}</b> dokumentów, o wartości <b>{{ paymentLocal.paymentAmount.toFixed(2) }} zł </b>)</p>

      <ScrollableListView title="Dokumenty opłacane:" :listContent="paymentDocumentNumbersJoinStr"></ScrollableListView>


    </div>
    <div v-if="showConfirmationButton">
      <button type="button" class="btn btn-primary" @click="confirmPayment">Potwierdź</button>
    </div>



  </div>

</template>


<script>
import ScrollableListView from "@/components/widgets/ScrollableListView.vue";

export default {
  name: "PaymentConfirmationModal",
  components: { ScrollableListView},
  props: {
    payment: Object,
    showConfirmationButton: Boolean
  },
  emits: ["onPaymentConfirmed"],
  data() {
    return {
      paymentLocal: this.payment
    };
  },
  computed: {
    paymentDocumentNumbersJoinStr() {

      if(this.paymentLocal == null || this.paymentLocal.paymentDocumentNumbers === undefined){
        return "";
      }

      return Object.values(this.paymentLocal.paymentDocumentNumbers).join(";");
    },


  },
  methods: {
    confirmPayment() {
      this.$emit("onPaymentConfirmed");
    },
  },
  watch: {},
  created() {
  }
};

</script>
<style scoped>

</style>
